const PROGRESS_STORAGE_KEY = 'pipeline_progress';

export interface UploadProgress {
  status:
    | 'idle'
    | 'scanning'
    | 'starting'
    | 'connected'
    | 'warming_up'
    | 'processing'
    | 'completed'
    | 'failed'
    | 'error'
    | 'cancelled';
  message: string;
  progress: number;
  recordsProcessed?: number;
  runId?: string;
}

export function loadPersistedProgress(): UploadProgress | null {
  try {
    const stored = localStorage.getItem(PROGRESS_STORAGE_KEY);
    if (!stored) return null;

    const progress = JSON.parse(stored);

    if (progress.timestamp) {
      const fiveMinutesAgo = Date.now() - 5 * 60 * 1000;
      if (
        progress.timestamp < fiveMinutesAgo &&
        ['completed', 'failed', 'cancelled'].includes(progress.status)
      ) {
        localStorage.removeItem(PROGRESS_STORAGE_KEY);
        return null;
      }
    }

    return progress;
  } catch {
    return null;
  }
}

export function persistProgress(progress: UploadProgress) {
  try {
    localStorage.setItem(
      PROGRESS_STORAGE_KEY,
      JSON.stringify({ ...progress, timestamp: Date.now() })
    );
  } catch {
    // Failed to persist progress
  }
}

export function clearPersistedProgress() {
  localStorage.removeItem(PROGRESS_STORAGE_KEY);
}
